(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.instance = {
    attach: function (context, settings) {
      once('instance', '.documents .files', context).forEach(function (block) {
        $('.documents .files').readmore({
          embedCSS: false,
          moreLink: '<a href="#">' + Drupal.t('Afficher tous les documents') + '<svg version="1.1" class="w-3 h-3 ml-2 fill-current" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
            '\t viewBox="0 0 5.7 8.5" style="enable-background:new 0 0 5.7 8.5;" xml:space="preserve">\n' +
            '<path d="M5,3.6L2.1,0.7c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l2.2,2.1L0.7,6.4c-0.4,0.4-0.4,1,0,1.4C0.9,8,1.2,8.1,1.4,8.1\n' +
            '\tS1.9,8,2.1,7.8L5,5c0.2-0.2,0.3-0.5,0.3-0.7C5.3,4,5.2,3.8,5,3.6z"/>\n' +
            '</svg></a>',
          lessLink: '<a href="#">' + Drupal.t('Fermer') + '<svg version="1.1" class="w-3 h-3 ml-2 fill-current transform -rotate-90" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
            '\t viewBox="0 0 5.7 8.5" style="enable-background:new 0 0 5.7 8.5;" xml:space="preserve">\n' +
            '<path d="M5,3.6L2.1,0.7c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l2.2,2.1L0.7,6.4c-0.4,0.4-0.4,1,0,1.4C0.9,8,1.2,8.1,1.4,8.1\n' +
            '\tS1.9,8,2.1,7.8L5,5c0.2-0.2,0.3-0.5,0.3-0.7C5.3,4,5.2,3.8,5,3.6z"/>\n' +
            '</svg></a>'
        });

      })
    }
  }
})(jQuery, Drupal, once, drupalSettings);
